import orderVerificationService from "src/services/orderVerificationService";

export const GET_ORDER_VERIFICATIONS_REQUEST =
  "@order-verification/get-order-verifications-request";
export const GET_ORDER_VERIFICATIONS_SUCCESS =
  "@order-verification/get-order-verifications-success";
export const GET_ORDER_VERIFICATIONS_FAILURE =
  "@order-verification/get-order-verifications-failure";

export const GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_REQUEST =
  "@order-verification/get-order-verifications-failed-delivery-request";
export const GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_SUCCESS =
  "@order-verification/get-order-verifications-failed-delivery-success";
export const GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_FAILURE =
  "@order-verification/get-order-verifications-failed-delivery-failure";

export const GET_ORDER_VERIFICATIONS_DUPLICATED_REQUEST =
  "@order-verification/get-order-verifications-duplicated-request";
export const GET_ORDER_VERIFICATIONS_DUPLICATED_SUCCESS =
  "@order-verification/get-order-verifications-duplicated-success";
export const GET_ORDER_VERIFICATIONS_DUPLICATED_FAILURE =
  "@order-verification/get-order-verifications-duplicated-failure";

export const GET_ORDER_VERIFICATIONS_HIGH_VALUE_REQUEST =
  "@order-verification/get-order-verifications-high-value-request";
export const GET_ORDER_VERIFICATIONS_HIGH_VALUE_SUCCESS =
  "@order-verification/get-order-verifications-high-value-success";
export const GET_ORDER_VERIFICATIONS_HIGH_VALUE_FAILURE =
  "@order-verification/get-order-verifications-high-value-failure";

export const GET_ORDER_VERIFICATIONS_CUSTOMER_REQUEST =
  "@order-verification/get-order-verifications-customer-request";
export const GET_ORDER_VERIFICATIONS_CUSTOMER_SUCCESS =
  "@order-verification/get-order-verifications-customer-success";
export const GET_ORDER_VERIFICATIONS_CUSTOMER_FAILURE =
  "@order-verification/get-order-verifications-customer-failure";

export const ADD_ORDER_VERIFICATION_FAILED_DELIVERY_REQUEST =
  "@order-verification/add-order-verifications-request";
export const ADD_ORDER_VERIFICATION_FAILED_DELIVERY_SUCCESS =
  "@order-verification/add-order-verifications-success";
export const ADD_ORDER_VERIFICATION_FAILED_DELIVERY_FAILURE =
  "@order-verification/add-order-verifications-failure";

export const ADD_ORDER_VERIFICATION_DUPLICATED_REQUEST =
  "@order-verification/add-order-duplication-verifications-request";
export const ADD_ORDER_VERIFICATION_DUPLICATED_SUCCESS =
  "@order-verification/add-order-duplication-verifications-success";
export const ADD_ORDER_VERIFICATION_DUPLICATED_FAILURE =
  "@order-verification/add-order-duplication-verifications-failure";

export const ADD_ORDER_VERIFICATION_HIGH_VALUE_REQUEST =
  "@order-verification/add-order-high-value-verifications-request";
export const ADD_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS =
  "@order-verification/add-order-high-value-verifications-success";
export const ADD_ORDER_VERIFICATION_HIGH_VALUE_FAILURE =
  "@order-verification/add-order-high-value-verifications-failure";

export const ADD_ORDER_VERIFICATION_CUSTOMER_REQUEST =
  "@order-verification/add-order-verifications-request";
export const ADD_ORDER_VERIFICATION_CUSTOMER_SUCCESS =
  "@order-verification/add-order-verifications-success";
export const ADD_ORDER_VERIFICATION_CUSTOMER_FAILURE =
  "@order-verification/add-order-verifications-failure";

export const GET_ONE_ORDER_VERIFICATION_REQUEST =
  "@order-verification/get-one-order-verifications-request";
export const GET_ONE_ORDER_VERIFICATION_SUCCESS =
  "@order-verification/get-one-order-verifications-success";
export const GET_ONE_ORDER_VERIFICATION_FAILURE =
  "@order-verification/get-one-order-verifications-failure";

export const UPDATE_ORDER_VERIFICATION_REQUEST =
  "@order-verification/update-order-verifications-request";
export const UPDATE_ORDER_VERIFICATION_SUCCESS =
  "@order-verification/update-order-verifications-success";
export const UPDATE_ORDER_VERIFICATION_FAILURE =
  "@order-verification/update-order-verifications-failure";

export const DELETE_ORDER_VERIFICATION_REQUEST =
  "@order-verification/delete-order-verification-request";
export const DELETE_ORDER_VERIFICATION_SUCCESS =
  "@order-verification/delete-order-verification-success";
export const DELETE_ORDER_VERIFICATION_FAILURE =
  "@order-verification/delete-order-verification-failure";

export const DELETE_ORDER_VERIFICATION_DUPLICATED_REQUEST =
  "@order-verification/delete-duplication-order-verification-request";
export const DELETE_ORDER_VERIFICATION_DUPLICATED_SUCCESS =
  "@order-verification/delete--duplicationorder-verification-success";
export const DELETE_ORDER_VERIFICATION_DUPLICATED_FAILURE =
  "@order-verification/delete-order-duplication-verification-failure";

export const DELETE_ORDER_VERIFICATION_HIGH_VALUE_REQUEST =
  "@order-verification/delete-order-high-value-verification-request";
export const DELETE_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS =
  "@order-verification/delete-order-high-value-verification-success";
export const DELETE_ORDER_VERIFICATION_HIGH_VALUE_FAILURE =
  "@order-verification/delete-order-high-value-verification-failure";

export const CLEAR_ORDER_VERIFICATION = "@order-verification/clear-order-verification";

export function getOrderVerification() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_VERIFICATIONS_REQUEST});
      const response = await orderVerificationService.getOrderVerification();
      dispatch({
        type: GET_ORDER_VERIFICATIONS_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_VERIFICATIONS_FAILURE});
      throw error;
    }
  };
}

export function getOrderVerificationFailedDelivery() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_REQUEST});
      const response =
        await orderVerificationService.getOrderVerificationFailedDelivery();
      dispatch({
        type: GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_FAILURE});
      throw error;
    }
  };
}
export function getOrderVerificationDuplicated() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_VERIFICATIONS_DUPLICATED_REQUEST});
      const response = await orderVerificationService.getOrderVerificationDuplicated();
      dispatch({
        type: GET_ORDER_VERIFICATIONS_DUPLICATED_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_VERIFICATIONS_DUPLICATED_FAILURE});
      throw error;
    }
  };
}
export function getOrderVerificationHighValue() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_VERIFICATIONS_HIGH_VALUE_REQUEST});
      const response = await orderVerificationService.getOrderVerificationHighValue();
      dispatch({
        type: GET_ORDER_VERIFICATIONS_HIGH_VALUE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_VERIFICATIONS_HIGH_VALUE_FAILURE});
      throw error;
    }
  };
}
export function getOrderVerificationCustomer() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_VERIFICATIONS_CUSTOMER_REQUEST});
      const response = await orderVerificationService.getOrderVerificationCustomer();
      dispatch({
        type: GET_ORDER_VERIFICATIONS_CUSTOMER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_VERIFICATIONS_CUSTOMER_FAILURE});
      throw error;
    }
  };
}

export function addOrderVerificationFailedDelivery(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_ORDER_VERIFICATION_FAILED_DELIVERY_REQUEST});
      const response = await orderVerificationService.addOrderVerificationFailedDelivery(
        data
      );
      dispatch({
        type: ADD_ORDER_VERIFICATION_FAILED_DELIVERY_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_ORDER_VERIFICATION_FAILED_DELIVERY_FAILURE});
      throw error;
    }
  };
}
export function addOrderVerificationDupcated(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_ORDER_VERIFICATION_DUPLICATED_REQUEST});
      const response = await orderVerificationService.addOrderVerificationDupcated(data);
      dispatch({
        type: ADD_ORDER_VERIFICATION_DUPLICATED_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_ORDER_VERIFICATION_DUPLICATED_FAILURE});
      throw error;
    }
  };
}
export function addOrderVerificationHighValue(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_ORDER_VERIFICATION_HIGH_VALUE_REQUEST});
      const response = await orderVerificationService.addOrderVerificationHighValue(data);
      dispatch({
        type: ADD_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_ORDER_VERIFICATION_HIGH_VALUE_FAILURE});
      throw error;
    }
  };
}
export function addOrderVerificationCustomer(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_ORDER_VERIFICATION_CUSTOMER_REQUEST});
      const response = await orderVerificationService.addOrderVerificationCustomer(data);
      dispatch({
        type: ADD_ORDER_VERIFICATION_CUSTOMER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_ORDER_VERIFICATION_CUSTOMER_FAILURE});
      throw error;
    }
  };
}

export function updateOrderVerification(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_ORDER_VERIFICATION_REQUEST});
      const response = await orderVerificationService.updateOrderVerification(data);
      dispatch({
        type: UPDATE_ORDER_VERIFICATION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_ORDER_VERIFICATION_FAILURE});
      throw error;
    }
  };
}
export function getOneOrderVerification(id) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_ORDER_VERIFICATION_REQUEST});
      const response = await orderVerificationService.getOneOrderVerification(id);
      dispatch({
        type: GET_ONE_ORDER_VERIFICATION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_ORDER_VERIFICATION_FAILURE});
      throw error;
    }
  };
}

export function deleteOrderVerification(orderVerification) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_ORDER_VERIFICATION_REQUEST});
      if (typeof orderVerification === "object") {
        await orderVerificationService.deleteOrderVerification(orderVerification.id);
      } else {
        await orderVerificationService.deleteOrderVerification(orderVerification);
      }
      dispatch({
        type: DELETE_ORDER_VERIFICATION_SUCCESS,
        payload: {
          orderVerification
        }
      });
    } catch (error) {
      dispatch({type: DELETE_ORDER_VERIFICATION_FAILURE});
      throw error;
    }
  };
}
export function deleteOrderVerificationHighValue(orderVerification) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_ORDER_VERIFICATION_HIGH_VALUE_REQUEST});
      if (typeof orderVerification === "object") {
        await orderVerificationService.deleteOrderVerificationHighValue(
          orderVerification.id
        );
      } else {
        await orderVerificationService.deleteOrderVerificationHighValue(
          orderVerification
        );
      }
      dispatch({
        type: DELETE_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS,
        payload: {
          orderVerification
        }
      });
    } catch (error) {
      dispatch({type: DELETE_ORDER_VERIFICATION_HIGH_VALUE_FAILURE});
      throw error;
    }
  };
}
export function deleteOrderVerificationDuplication(orderVerification) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_ORDER_VERIFICATION_DUPLICATED_REQUEST});
      if (typeof orderVerification === "object") {
        await orderVerificationService.deleteOrderVerificationDuplication(
          orderVerification.id
        );
      } else {
        await orderVerificationService.deleteOrderVerificationDuplication(
          orderVerification
        );
      }
      dispatch({
        type: DELETE_ORDER_VERIFICATION_DUPLICATED_SUCCESS,
        payload: {
          orderVerification
        }
      });
    } catch (error) {
      dispatch({type: DELETE_ORDER_VERIFICATION_DUPLICATED_FAILURE});
      throw error;
    }
  };
}

export function clearOrderVerification() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ORDER_VERIFICATION
    });
  };
}
